import * as z from "zod";
//#region src/__generated__/internal/application/zod/tuPartBindResultSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const tuPartBindResultSchema = z.object({
	fileId: z.uuid().describe("Идентификатор привязанного файла"),
	previousFileId: z.uuid().nullish().describe("Идентификатор заменённого файла; null при первичной привязке и при безопасном same-ID no-op")
}).describe("Результат привязки актуальной части ТУ к подразделению");
//#endregion
//#region src/__generated__/internal/application/zod/bindSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const bindPathRequestIdSchema = z.uuid();
const bindPathDepartmentIdSchema = z.string();
const bindPathFileIdSchema = z.uuid();
const bindStatus200Schema = tuPartBindResultSchema.describe("Результат привязки актуальной части ТУ к подразделению");
const bindResponseSchema = bindStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/finalDecisionBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionBodySchema = z.object({
	decision: z.enum(["APPROVED", "REJECTED"]).describe("Решение по заявке"),
	documentIds: z.array(z.uuid()).min(1),
	justification: z.string().min(1)
}).describe("Данные черновика итогового решения");
//#endregion
//#region src/__generated__/internal/application/zod/finalDecisionAuthorDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionAuthorDtoSchema = z.object({
	firstName: z.string().nullish(),
	id: z.uuid(),
	lastName: z.string().nullish(),
	middleName: z.string().nullish()
}).describe("Неизменяемый снимок автора черновика итогового решения");
//#endregion
//#region src/__generated__/internal/application/zod/finalDecisionDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionDtoSchema = z.object({
	author: finalDecisionAuthorDtoSchema.nullish().describe("Неизменяемый снимок автора черновика итогового решения"),
	createdAt: z.iso.datetime().nullish(),
	decision: z.enum(["APPROVED", "REJECTED"]).optional().describe("Решение по заявке"),
	documentIds: z.array(z.uuid()).nullish(),
	id: z.uuid().nullish(),
	justification: z.string().nullish(),
	updatedAt: z.iso.datetime().nullish()
}).describe("Черновик итогового решения");
//#endregion
//#region src/__generated__/internal/application/zod/createSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createPathRequestIdSchema = z.uuid();
const createStatus200Schema = finalDecisionDtoSchema.describe("Черновик итогового решения");
const createResponseSchema = createStatus200Schema;
const createDataSchema = finalDecisionBodySchema.describe("Данные черновика итогового решения");
//#endregion
//#region src/__generated__/internal/application/zod/finalDecisionRemarkBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionRemarkBodySchema = z.object({
	comment: z.string().min(1),
	documentIds: z.array(z.uuid()).optional().describe("Документы замечания; пустой список допустим")
}).describe("Замечание к текущей версии итогового решения");
//#endregion
//#region src/__generated__/internal/application/zod/finalDecisionRemarkDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionRemarkDtoSchema = z.object({
	author: finalDecisionAuthorDtoSchema.nullish().describe("Неизменяемый снимок автора черновика итогового решения"),
	comment: z.string().nullish(),
	createdAt: z.iso.datetime().nullish(),
	deletedAt: z.iso.datetime().nullish(),
	documentIds: z.array(z.uuid()).nullish(),
	id: z.uuid().nullish(),
	stage: z.enum(["NTP", "NG"]).optional()
}).describe("Замечание согласующего к версии итогового решения");
//#endregion
//#region src/__generated__/internal/application/zod/createRemarkSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createRemarkPathRequestIdSchema = z.uuid();
const createRemarkStatus200Schema = finalDecisionRemarkDtoSchema.describe("Замечание согласующего к версии итогового решения");
const createRemarkResponseSchema = createRemarkStatus200Schema;
const createRemarkDataSchema = finalDecisionRemarkBodySchema.describe("Замечание к текущей версии итогового решения");
//#endregion
//#region src/__generated__/internal/application/zod/deleteAttachmentDescriptionSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteAttachmentDescriptionPathIdSchema = z.uuid();
const deleteAttachmentDescriptionPathFileIdSchema = z.uuid();
const deleteAttachmentDescriptionStatus204Schema = z.unknown();
const deleteAttachmentDescriptionResponseSchema = deleteAttachmentDescriptionStatus204Schema;
//#endregion
//#region src/__generated__/internal/application/zod/deleteRemarkSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteRemarkPathRequestIdSchema = z.uuid();
const deleteRemarkPathRemarkIdSchema = z.uuid();
const deleteRemarkStatus204Schema = z.unknown();
const deleteRemarkResponseSchema = deleteRemarkStatus204Schema;
//#endregion
//#region src/__generated__/internal/application/zod/requestExportRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestExportRequestSchema = z.object({ ids: z.array(z.uuid()).min(1).describe("Идентификаторы заявок для экспорта") }).describe("Тело запроса на пакетный экспорт результата заявок в один архив");
//#endregion
//#region src/__generated__/internal/application/zod/exportRequestsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const exportRequestsStatus200Schema = z.object({}).catchall(z.unknown());
const exportRequestsResponseSchema = exportRequestsStatus200Schema;
const exportRequestsDataSchema = requestExportRequestSchema.describe("Тело запроса на пакетный экспорт результата заявок в один архив");
//#endregion
//#region src/__generated__/internal/application/zod/get2Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const get2PathRequestIdSchema = z.uuid();
const get2Status200Schema = finalDecisionDtoSchema.describe("Черновик итогового решения");
const get2ResponseSchema = get2Status200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/tileCountSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const tileCountSchema = z.object({
	count: z.int().nullish().describe("Значение счётчика; null — плашка зарезервирована и ещё не считается (OVERDUE_RISK до BAC-2221)"),
	key: z.enum([
		"TOTAL",
		"NEW",
		"AT_NG",
		"AT_RAILWAY",
		"NEEDS_ATTENTION",
		"OVERDUE_RISK",
		"IN_NTP",
		"NG_APPROVAL",
		"DECISION_REWORK",
		"SENT_TO_NG",
		"IN_NG",
		"SENT_TO_NTP",
		"NTP_APPROVAL",
		"NTP_RESP_ASSIGNED",
		"COMMISSION_PREP",
		"DECISION_FORMING",
		"NEEDS_EXPORT",
		"EXPORTED",
		"LOADED"
	]).optional().describe("Ключ плашки")
}).describe("Ролевая плашка реестра");
//#endregion
//#region src/__generated__/internal/application/zod/requestStatusCountsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestStatusCountsSchema = z.object({
	byStatus: z.object({}).catchall(z.int()).nullish().describe("Количество заявок по каждому статусу"),
	needsAttention: z.int().nullish().describe("Требующие внимания (REVISION_REQUIRED)"),
	needsExport: z.int().nullish().describe("Требующие выгрузки в другой контур (терминальный статус без выгруженного результата, либо есть непереданный счёт — независимо от статуса)"),
	tiles: z.array(tileCountSchema).nullish().describe("Ролевые плашки реестра (набор определяется ролью); null — для ролей без настроенного набора"),
	total: z.int().nullish().describe("Всего заявок")
}).describe("Сводка-счётчики заявок по статусам");
//#endregion
//#region src/__generated__/internal/application/zod/getCountsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getCountsStatus200Schema = requestStatusCountsSchema.describe("Сводка-счётчики заявок по статусам");
const getCountsResponseSchema = getCountsStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/finalDecisionApprovalDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionApprovalDtoSchema = z.object({
	actor: finalDecisionAuthorDtoSchema.nullish().describe("Неизменяемый снимок автора черновика итогового решения"),
	decidedAt: z.iso.datetime().nullish(),
	id: z.uuid().nullish(),
	outcome: z.enum(["APPROVED", "RETURNED"]).optional(),
	stage: z.enum(["NTP", "NG"]).optional(),
	versionNumber: z.int().nullish()
}).describe("Неизменяемый результат согласования версии итогового решения");
//#endregion
//#region src/__generated__/internal/application/zod/finalDecisionVersionDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionVersionDtoSchema = z.object({
	approvalStatus: z.enum([
		"INTAKE_CHECK",
		"REVISION_REQUIRED",
		"SENT_TO_NG",
		"IN_NG",
		"SENT_TO_NTP",
		"IN_NTP",
		"NTP_RESP_ASSIGNED",
		"COMMISSION_PREP",
		"DECISION_FORMING",
		"NTP_APPROVAL",
		"NG_APPROVAL",
		"DECISION_REWORK",
		"TU_ISSUED",
		"REJECTED"
	]).optional().describe("Статус заявки во внутреннем контуре"),
	approvals: z.array(finalDecisionApprovalDtoSchema).nullish(),
	author: finalDecisionAuthorDtoSchema.nullish().describe("Неизменяемый снимок автора черновика итогового решения"),
	decision: z.enum(["APPROVED", "REJECTED"]).optional().describe("Решение по заявке"),
	documentIds: z.array(z.uuid()).nullish(),
	justification: z.string().nullish(),
	remarks: z.array(finalDecisionRemarkDtoSchema).nullish(),
	submittedAt: z.iso.datetime().nullish(),
	versionNumber: z.int().nullish()
});
//#endregion
//#region src/__generated__/internal/application/zod/getCurrentVersionSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getCurrentVersionPathRequestIdSchema = z.uuid();
const getCurrentVersionStatus200Schema = finalDecisionVersionDtoSchema;
const getCurrentVersionResponseSchema = getCurrentVersionStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/filterValueItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const filterValueItemSchema = z.object({
	displayName: z.string().nullish().describe("Отображаемое название"),
	value: z.string().nullish().describe("Значение для передачи в фильтр")
}).describe("Доступное значение фильтра");
//#endregion
//#region src/__generated__/internal/application/zod/getFilterValuesSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFilterValuesQueryColumnSchema = z.enum([
	"SECTION",
	"APPLICANT_NAME",
	"INITIATOR",
	"ASSIGNEE",
	"OPERATOR"
]).describe("Колонка, для которой запрашиваются доступные значения фильтра");
const getFilterValuesQueryQSchema = z.string().optional();
const getFilterValuesQueryLimitSchema = z.int().optional();
const getFilterValuesQuerySelectedSchema = z.array(z.string()).optional();
const getFilterValuesQueryMonitoringMetricSchema = z.enum([
	"TOTAL",
	"ACTIVE",
	"TU_ISSUED",
	"REJECTED",
	"PAID_SERVICE",
	"FREE_SERVICE",
	"INVOICE_TOTAL",
	"PAYMENT_TOTAL",
	"DEBT_TOTAL",
	"ACTIVE_PLANNED",
	"ACTIVE_APPROACHING",
	"ACTIVE_AT_RISK",
	"ACTIVE_OVERDUE",
	"ACTIVE_PAID_SERVICE",
	"ACTIVE_FREE_SERVICE",
	"ACTIVE_UNDEFINED_PAYMENT",
	"ACTIVE_AWAITING_INVOICE",
	"ACTIVE_AWAITING_PAYMENT",
	"ACTIVE_PAID",
	"ACTIVE_INVOICE_TOTAL",
	"ACTIVE_PAYMENT_TOTAL",
	"ACTIVE_DEBT_TOTAL"
]).optional();
const getFilterValuesStatus200Schema = z.array(filterValueItemSchema);
const getFilterValuesResponseSchema = getFilterValuesStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/approverDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const approverDtoSchema = z.object({
	email: z.string().nullish().describe("Email согласующего").meta({ examples: ["approver@example.com"] }),
	firstName: z.string().nullish().describe("Имя").meta({ examples: ["Пётр"] }),
	internalUserId: z.uuid().nullish().describe("Идентификатор внутреннего пользователя").meta({ examples: ["550e8400-e29b-41d4-a716-446655440000"] }),
	lastName: z.string().nullish().describe("Фамилия").meta({ examples: ["Петров"] }),
	middleName: z.string().nullish().describe("Отчество").meta({ examples: ["Петрович"] })
}).describe("Данные согласующего из Keycloak");
//#endregion
//#region src/__generated__/internal/application/zod/assignmentPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const assignmentPayloadSchema = z.object({
	assigneeId: z.uuid().nullish().describe("Назначенный исполнитель"),
	assigneeName: z.string().nullish().describe("ФИО назначенного на момент события").meta({ examples: ["Сидоров Сидор Сидорович"] }),
	previousAssigneeId: z.uuid().nullish().describe("Прежний исполнитель; отсутствует при первичном назначении"),
	reason: z.string().nullish().describe("Причина переназначения"),
	slot: z.enum([
		"NG_STAFF",
		"NTP_HEAD",
		"NTP_RESPONSIBLE"
	]).optional().describe("Слот, для которого назначен исполнитель")
}).describe("Назначение исполнителя слота");
//#endregion
//#region src/__generated__/internal/application/zod/emptyPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const emptyPayloadSchema = z.unknown().describe("Событие без дополнительных параметров");
//#endregion
//#region src/__generated__/internal/application/zod/importPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const importPayloadSchema = z.object({
	commentsImported: z.int().nullish().describe("Сколько комментариев добавлено этим импортом"),
	externalRequestId: z.uuid().nullish().describe("Идентификатор заявки во внешнем контуре"),
	filesImported: z.int().nullish().describe("Сколько файлов добавлено этим импортом"),
	from: z.enum([
		"INTAKE_CHECK",
		"REVISION_REQUIRED",
		"SENT_TO_NG",
		"IN_NG",
		"SENT_TO_NTP",
		"IN_NTP",
		"NTP_RESP_ASSIGNED",
		"COMMISSION_PREP",
		"DECISION_FORMING",
		"NTP_APPROVAL",
		"NG_APPROVAL",
		"DECISION_REWORK",
		"TU_ISSUED",
		"REJECTED"
	]).optional().describe("Статус до возобновления; только для возобновления после доработки"),
	number: z.int().nullish().describe("Номер заявки"),
	to: z.enum([
		"INTAKE_CHECK",
		"REVISION_REQUIRED",
		"SENT_TO_NG",
		"IN_NG",
		"SENT_TO_NTP",
		"IN_NTP",
		"NTP_RESP_ASSIGNED",
		"COMMISSION_PREP",
		"DECISION_FORMING",
		"NTP_APPROVAL",
		"NG_APPROVAL",
		"DECISION_REWORK",
		"TU_ISSUED",
		"REJECTED"
	]).optional().describe("Статус после возобновления; только для возобновления после доработки")
}).describe("Импорт заявки из внешнего контура");
//#endregion
//#region src/__generated__/internal/application/zod/invoicePayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const invoicePayloadSchema = z.object({
	amount: z.number().nullish().describe("Сумма счёта").meta({ examples: [15e3] }),
	invoiceNumber: z.string().nullish().describe("Номер счёта")
}).describe("Счёт на оплату");
//#endregion
//#region src/__generated__/internal/application/zod/paymentConfirmationPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const paymentConfirmationPayloadSchema = z.object({
	externalRequestId: z.uuid().nullish().describe("Идентификатор заявки во внешнем контуре"),
	proofFileName: z.string().nullish().describe("Имя файла подтверждения из архива")
}).describe("Подтверждение оплаты");
//#endregion
//#region src/__generated__/internal/application/zod/paymentFlagPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const paymentFlagPayloadSchema = z.object({
	from: z.enum([
		"UNDER_REVIEW",
		"NO_PAYMENT",
		"PAID"
	]).optional().describe("Признак до изменения"),
	to: z.enum([
		"UNDER_REVIEW",
		"NO_PAYMENT",
		"PAID"
	]).optional().describe("Признак после изменения")
}).describe("Смена признака оплаты");
//#endregion
//#region src/__generated__/internal/application/zod/reasonPayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const reasonPayloadSchema = z.object({ reason: z.string().nullish().describe("Причина события").meta({ examples: ["NG_REWORK"] }) }).describe("Событие с указанием причины");
//#endregion
//#region src/__generated__/internal/application/zod/statusChangePayloadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const statusChangePayloadSchema = z.object({
	decision: z.enum(["APPROVED", "REJECTED"]).optional().describe("Итоговое решение; только для завершающих переходов"),
	from: z.enum([
		"INTAKE_CHECK",
		"REVISION_REQUIRED",
		"SENT_TO_NG",
		"IN_NG",
		"SENT_TO_NTP",
		"IN_NTP",
		"NTP_RESP_ASSIGNED",
		"COMMISSION_PREP",
		"DECISION_FORMING",
		"NTP_APPROVAL",
		"NG_APPROVAL",
		"DECISION_REWORK",
		"TU_ISSUED",
		"REJECTED"
	]).optional().describe("Статус до перехода"),
	returnStage: z.enum([
		"INTAKE_CHECK",
		"REVISION_REQUIRED",
		"SENT_TO_NG",
		"IN_NG",
		"SENT_TO_NTP",
		"IN_NTP",
		"NTP_RESP_ASSIGNED",
		"COMMISSION_PREP",
		"DECISION_FORMING",
		"NTP_APPROVAL",
		"NG_APPROVAL",
		"DECISION_REWORK",
		"TU_ISSUED",
		"REJECTED"
	]).optional().describe("Этап, на который заявка вернётся; только для отправки на доработку"),
	to: z.enum([
		"INTAKE_CHECK",
		"REVISION_REQUIRED",
		"SENT_TO_NG",
		"IN_NG",
		"SENT_TO_NTP",
		"IN_NTP",
		"NTP_RESP_ASSIGNED",
		"COMMISSION_PREP",
		"DECISION_FORMING",
		"NTP_APPROVAL",
		"NG_APPROVAL",
		"DECISION_REWORK",
		"TU_ISSUED",
		"REJECTED"
	]).optional().describe("Статус после перехода")
}).describe("Переход статуса заявки");
//#endregion
//#region src/__generated__/internal/application/zod/internalRequestEventLogDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const internalRequestEventLogDtoSchema = z.object({
	actor: z.uuid().nullish().describe("Идентификатор инициатора действия (Keycloak subject)"),
	actorInfo: approverDtoSchema.nullish().describe("ФИО инициатора действия на момент события; email не заполняется"),
	actorRole: z.string().nullish().describe("Роль инициатора"),
	eventType: z.enum([
		"INTAKE_PASS",
		"REQUEST_REVISION",
		"REJECT",
		"TAKE_NG",
		"SEND_TO_NTP",
		"TAKE_NTP",
		"ASSIGN_NTP_RESP",
		"START_COMMISSION_PREP",
		"START_DECISION",
		"SUBMIT_NTP_APPROVAL",
		"NTP_REWORK",
		"NTP_APPROVE",
		"NG_REWORK",
		"NG_APPROVE",
		"REWORK_RESUBMIT",
		"ASSIGN",
		"REASSIGN",
		"IMPORTED",
		"IMPORT_UPDATED",
		"RESUMED",
		"PAYMENT_CONFIRMED",
		"EXPORT_RESULT",
		"PAYMENT_FLAG_SET",
		"INVOICE_ISSUED",
		"INVOICE_UPDATED",
		"INVOICE_SENT",
		"PAYMENT_AWAITING"
	]).optional().describe("Тип события; определяет форму payload"),
	id: z.uuid().nullish().describe("Идентификатор записи журнала"),
	occurredAt: z.iso.datetime().nullish().describe("Время события").meta({ examples: ["2026-04-16T11:00:00Z"] }),
	payload: z.union([
		statusChangePayloadSchema.strict(),
		assignmentPayloadSchema.strict(),
		importPayloadSchema.strict(),
		invoicePayloadSchema.strict(),
		paymentConfirmationPayloadSchema.strict(),
		paymentFlagPayloadSchema.strict(),
		reasonPayloadSchema.strict(),
		emptyPayloadSchema
	]).nullish().describe("Дополнительные параметры события; форма определяется eventType")
}).describe("Запись журнала действий по внутренней заявке");
//#endregion
//#region src/__generated__/internal/application/zod/getHistorySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getHistoryPathIdSchema = z.uuid();
const getHistoryStatus200Schema = z.array(internalRequestEventLogDtoSchema);
const getHistoryResponseSchema = getHistoryStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/pageResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const pageResponseSchema = z.object({
	content: z.array(z.unknown()).nullish().describe("Элементы страницы"),
	page: z.int().nullish().describe("Номер текущей страницы (0-based)").meta({ examples: [0] }),
	size: z.int().nullish().describe("Размер страницы").meta({ examples: [20] }),
	totalElements: z.int().nullish().describe("Общее количество элементов").meta({ examples: [142] }),
	totalPages: z.int().nullish().describe("Общее количество страниц").meta({ examples: [8] })
}).describe("Пагинированный ответ");
//#endregion
//#region src/__generated__/internal/application/zod/getNeedsAttentionSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getNeedsAttentionQuerySearchSchema = z.string().optional();
const getNeedsAttentionQueryPageSchema = z.int().optional();
const getNeedsAttentionQuerySizeSchema = z.int().optional();
const getNeedsAttentionStatus200Schema = pageResponseSchema.describe("Пагинированный ответ");
const getNeedsAttentionResponseSchema = getNeedsAttentionStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/finalDecisionRefusalDocumentDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionRefusalDocumentDtoSchema = z.object({
	fileId: z.uuid().nullish(),
	name: z.string().nullish()
}).describe("Документ мотивированного отказа");
//#endregion
//#region src/__generated__/internal/application/zod/finalDecisionRefusalDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionRefusalDtoSchema = z.object({
	author: finalDecisionAuthorDtoSchema.nullish().describe("Неизменяемый снимок автора черновика итогового решения"),
	decidedAt: z.iso.datetime().nullish(),
	decision: z.enum(["APPROVED", "REJECTED"]).optional().describe("Решение по заявке"),
	documents: z.array(finalDecisionRefusalDocumentDtoSchema).nullish(),
	justification: z.string().nullish()
}).describe("Опубликованный мотивированный отказ");
//#endregion
//#region src/__generated__/internal/application/zod/getRefusalSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getRefusalPathRequestIdSchema = z.uuid();
const getRefusalStatus200Schema = finalDecisionRefusalDtoSchema.describe("Опубликованный мотивированный отказ");
const getRefusalResponseSchema = getRefusalStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/applicantDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const applicantDtoSchema = z.object({
	contactPhone: z.string().nullish().describe("Контактный телефон").meta({ examples: ["+7 900 000-00-00"] }),
	corporateEmail: z.string().nullish().describe("Корпоративная почта").meta({ examples: ["ivanov@romashka.ru"] }),
	email: z.string().nullish().describe("Email учётной записи").meta({ examples: ["applicant@example.com"] }),
	firstName: z.string().nullish().describe("Имя").meta({ examples: ["Иван"] }),
	lastName: z.string().nullish().describe("Фамилия").meta({ examples: ["Иванов"] }),
	middleName: z.string().nullish().describe("Отчество").meta({ examples: ["Иванович"] }),
	organization: z.string().nullish().describe("Организация").meta({ examples: ["ООО «Ромашка»"] }),
	position: z.string().nullish().describe("Должность").meta({ examples: ["Главный инженер"] })
}).describe("Данные заявителя");
//#endregion
//#region src/__generated__/internal/application/zod/fileMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSchema = z.object({
	author: z.uuid(),
	baseName: z.string(),
	createdAt: z.iso.datetime(),
	ext: z.string().nullish(),
	hash: z.string().nullish(),
	id: z.uuid(),
	isBlocked: z.boolean(),
	isDeleted: z.boolean(),
	modifiedAt: z.iso.datetime(),
	parentId: z.uuid().nullish(),
	preview: z.string().nullish().describe("Файл preview закодированный в base64. Поле может быть null, если для данного элемента не поддерживаются preview либо, если для данного элемента preview еще не было получено/сконвертировано."),
	previewId: z.uuid().nullish(),
	size: z.int(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"EKPTD_RESOURCE",
		"EKPTD_ROLE_APPLICATION",
		"EKPTD_REJECT_ROLE_APPLICATION",
		"EKPTD_REVOKE_ROLE_APPLICATION",
		"LIBRARY",
		"KNOWLEDGE_BASE",
		"EXTERNAL_REQUEST",
		"INTERNAL_REQUEST",
		"INTERNAL_REQUEST_SUPPORTING",
		"INTERNAL_REQUEST_TU_PART",
		"INTERNAL_REQUEST_FINAL_DECISION",
		"EXTERNAL_REQUEST_FINAL_DECISION"
	]),
	type: z.enum([
		"DIRECTORY",
		"DOCUMENT",
		"CLASSIFIER_DOCUMENT",
		"MODEL",
		"MODEL_DATA",
		"MODEL_DATA_SIMPLIFIED",
		"IMAGE",
		"COMMENT_DOCUMENT",
		"COSMOS_DOCUMENT",
		"COSMOS_GEOSERVER_DOCUMENT",
		"BUILDING_MANAGEMENT_DOCUMENT",
		"TASK_TRACKER",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"ONTOLOGY_DOCUMENT",
		"COLLISION_DOCUMENT",
		"ROLE_APPLICATION",
		"RESOURCE_DOCUMENT",
		"LIBRARY_DOCUMENT",
		"KNOWLEDGE_BASE_DOCUMENT",
		"REQUEST_DOCUMENT",
		"SUPPORTING_DOCUMENT"
	]),
	version: z.int(),
	versionParentId: z.uuid().nullish().describe("Id первой версии этого файла. Присутствует только если поле version > 1")
});
//#endregion
//#region src/__generated__/internal/application/zod/stageAssignmentDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const stageAssignmentDtoSchema = z.object({
	assignedAt: z.iso.datetime().nullish(),
	assignedBy: z.uuid().nullish(),
	assignee: approverDtoSchema.nullish().describe("Данные согласующего из Keycloak"),
	reason: z.string().nullish(),
	slot: z.enum([
		"NG_STAFF",
		"NTP_HEAD",
		"NTP_RESPONSIBLE"
	]).optional()
}).describe("Занятый слот участника процесса");
//#endregion
//#region src/__generated__/internal/application/zod/internalRequestDetailResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const internalRequestDetailResponseSchema = z.object({
	additionalData: z.string().nullish().describe("Дополнительные данные"),
	adjoiningType: z.enum(["DIRECT_RZD", "VIA_OTHER_OWNER"]).optional().describe("Тип примыкания"),
	applicant: applicantDtoSchema.nullish().describe("Данные заявителя"),
	applicantAddress: z.string().nullish().describe("Адрес"),
	applicantEmail: z.string().nullish().describe("Контактная почта"),
	applicantInn: z.string().nullish().describe("ИНН"),
	applicantKpp: z.string().nullish().describe("КПП"),
	applicantName: z.string().nullish().describe("Наименование организации/ФИО"),
	applicantOkpo: z.string().nullish().describe("ОКПО"),
	applicantPhone: z.string().nullish().describe("Контактный телефон"),
	applicantType: z.enum([
		"INDIVIDUAL",
		"SOLE_PROPRIETOR",
		"LEGAL_ENTITY"
	]).optional().describe("Тип заявителя (адресата)"),
	assignee: approverDtoSchema.nullish().describe("Пользователь, назначенный на обработку заявки на текущем этапе"),
	assignments: z.array(stageAssignmentDtoSchema).nullish().describe("Занятые слоты участников процесса"),
	createdAt: z.iso.datetime().nullish().describe("Дата создания записи во внутреннем контуре (для исторических заявок = дате импорта)"),
	currentAssignee: approverDtoSchema.nullish().describe("Исполнитель, у которого заявка находится сейчас (держатель слота текущего статуса)"),
	deadlineControl: z.enum([
		"PLANNED",
		"DEADLINE_APPROACHING",
		"RISK_OF_VIOLATION",
		"OVERDUE",
		"REVIEWED"
	]).optional().describe("Контроль срока").meta({ examples: ["PLANNED"] }),
	displayStatus: z.string().nullish().describe("Отображаемый статус").meta({ examples: ["Входной контроль"] }),
	exportedAt: z.iso.datetime().nullish().describe("Дата выгрузки результата из внутреннего контура (null — не выгружена)"),
	externalCreatedAt: z.iso.datetime().nullish().describe("Дата создания заявки во внешнем контуре"),
	externalRequestId: z.uuid().nullish().describe("Идентификатор заявки во внешнем контуре"),
	files: z.array(fileMetaDtoSchema).nullish().describe("Список файлов, прикреплённых к заявке"),
	finalDecision: z.enum(["APPROVED", "REJECTED"]).optional().describe("Итоговое решение"),
	finalDecisionApprovals: z.array(finalDecisionApprovalDtoSchema).nullish().describe("Последний результат каждого этапа согласования итогового решения"),
	id: z.uuid().nullish().describe("Идентификатор заявки"),
	importedAt: z.iso.datetime().nullish().describe("Дата первого поступления заявки во внутренний контур (фиксируется один раз)"),
	initiator: applicantDtoSchema.nullish().describe("Заявитель, создавший заявку"),
	invoiceAmount: z.number().nullish().describe("Стоимость услуги в рублях: сумма выставленного счёта платной заявки; иначе null"),
	needsExport: z.boolean().nullish().describe("УСТАРЕЛО: дублирует processingFlag == NEEDS_EXPORT, будет удалено. Признак: заявка требует выгрузки в другой контур"),
	number: z.int().nullish().describe("Номер заявки").meta({ examples: [1001] }),
	objectDescription: z.string().nullish().describe("Структурированное описание объекта (raw JSON)"),
	operator: approverDtoSchema.nullish().describe("Пользователь, выполнивший последнее действие по заявке (только для роли Оператор)"),
	paymentFlag: z.enum([
		"UNDER_REVIEW",
		"NO_PAYMENT",
		"PAID"
	]).optional().describe("Условия оплаты — текущий признак оплаты по заявке"),
	plannedWorksType: z.enum([
		"NEW_TRACK_CONSTRUCTION",
		"RECONSTRUCTION",
		"RESTORATION",
		"DEVELOPMENT"
	]).optional().describe("Вид планируемых работ"),
	processedAt: z.iso.datetime().nullish().describe("Дата обработки результата (только для \"Выгружено\", иначе null; только для роли Оператор)"),
	processingFlag: z.enum([
		"NEEDS_EXPORT",
		"EXPORTED",
		"LOADED"
	]).optional().describe("Признак обработки заявки Оператором (только для роли Оператор)"),
	railway: z.enum([
		"VOSTOCHNO_SIBIRSKAYA",
		"GORKOVSKAYA",
		"DALNEVOSTOCHNAYA",
		"ZABAYKALSKAYA",
		"ZAPADNO_SIBIRSKAYA",
		"KALININGRADSKAYA",
		"KRASNOYARSKAYA",
		"KUYBYSHEVSKAYA",
		"MOSKOVSKAYA",
		"OKTYABRSKAYA",
		"PRIVOLZHSKAYA",
		"SVERDLOVSKAYA",
		"SEVERNAYA",
		"SEVERO_KAVKAZSKAYA",
		"YUGO_VOSTOCHNAYA",
		"YUZHNO_URALSKAYA"
	]).optional().describe("Железная дорога"),
	receivedAt: z.iso.datetime().nullish().describe("Дата поступления/загрузки во внутренний контур (для \"Требуется выгрузка\" и \"Загружено\"; для \"Выгружено\" — null; только для роли Оператор)"),
	remainingDays: z.int().nullish().describe("Осталось рабочих дней до окончания срока (отрицательное — дни просрочки); null — день поступления либо заявка рассмотрена. Во время паузы срока значение заморожено"),
	requestSubject: z.enum(["ADJOINING", "CROSSING"]).optional().describe("Вид обращения"),
	resolvedAt: z.iso.datetime().nullish().describe("Дата вынесения итогового решения"),
	resultFileId: z.uuid().nullish().describe("ID результирующего документа в file-service. Заполняется только после finalize, если был передан при завершении. null, если исход опубликован документами итогового решения."),
	reviewDueDate: z.iso.date().nullish().describe("Рассмотреть до: дата окончания контрольного срока рассмотрения"),
	section: z.string().nullish().describe("Участок"),
	sentForReviewAt: z.iso.datetime().nullish().describe("Дата отправки на согласование"),
	status: z.enum([
		"INTAKE_CHECK",
		"REVISION_REQUIRED",
		"SENT_TO_NG",
		"IN_NG",
		"SENT_TO_NTP",
		"IN_NTP",
		"NTP_RESP_ASSIGNED",
		"COMMISSION_PREP",
		"DECISION_FORMING",
		"NTP_APPROVAL",
		"NG_APPROVAL",
		"DECISION_REWORK",
		"TU_ISSUED",
		"REJECTED"
	]).optional().describe("Статус заявки").meta({ examples: ["INTAKE_CHECK"] }),
	title: z.string().nullish().describe("Заголовок заявки").meta({ examples: ["Заявка на согласование"] }),
	trackFunding: z.enum([
		"APPLICANT_FUNDS",
		"RZD_INVESTMENT",
		"SHARED",
		"OTHER"
	]).optional().describe("Функциональное назначение пути"),
	type: z.enum([
		"TU_ISSUE",
		"TU_CHANGE",
		"APPROVAL"
	]).optional().describe("Тип заявки").meta({ examples: ["TU_ISSUE"] }),
	updatedAt: z.iso.datetime().nullish().describe("Дата последнего изменения заявки во внутреннем контуре")
}).describe("Детальная информация о заявке");
//#endregion
//#region src/__generated__/internal/application/zod/getRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getRequestPathIdSchema = z.uuid();
const getRequestStatus200Schema = internalRequestDetailResponseSchema.describe("Детальная информация о заявке");
const getRequestResponseSchema = getRequestStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/getRequestsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getRequestsQuerySearchSchema = z.string().optional().describe("Поиск по вхождению в title без учёта регистра и в number; поддерживается номер вида №012345");
const getRequestsQueryStatusSchema = z.array(z.enum([
	"INTAKE_CHECK",
	"REVISION_REQUIRED",
	"SENT_TO_NG",
	"IN_NG",
	"SENT_TO_NTP",
	"IN_NTP",
	"NTP_RESP_ASSIGNED",
	"COMMISSION_PREP",
	"DECISION_FORMING",
	"NTP_APPROVAL",
	"NG_APPROVAL",
	"DECISION_REWORK",
	"TU_ISSUED",
	"REJECTED"
])).optional().describe("Фильтр по статусам (повторяемый параметр)");
const getRequestsQueryTypeSchema = z.enum([
	"TU_ISSUE",
	"TU_CHANGE",
	"APPROVAL"
]).optional().describe("Фильтр по типу заявки");
const getRequestsQueryRequestSubjectSchema = z.array(z.enum(["ADJOINING", "CROSSING"])).optional().describe("Фильтр по виду обращения — Примыкание/Пересечение (повторяемый параметр). В стори эта колонка называется «Тип заявки»; параметр type — про другой справочник (Выдача/Изменение ТУ, Согласование)");
const getRequestsQueryRailwaySchema = z.array(z.enum([
	"VOSTOCHNO_SIBIRSKAYA",
	"GORKOVSKAYA",
	"DALNEVOSTOCHNAYA",
	"ZABAYKALSKAYA",
	"ZAPADNO_SIBIRSKAYA",
	"KALININGRADSKAYA",
	"KRASNOYARSKAYA",
	"KUYBYSHEVSKAYA",
	"MOSKOVSKAYA",
	"OKTYABRSKAYA",
	"PRIVOLZHSKAYA",
	"SVERDLOVSKAYA",
	"SEVERNAYA",
	"SEVERO_KAVKAZSKAYA",
	"YUGO_VOSTOCHNAYA",
	"YUZHNO_URALSKAYA"
])).optional().describe("Фильтр по дорогам (повторяемый параметр)");
const getRequestsQueryApplicantTypeSchema = z.array(z.enum([
	"INDIVIDUAL",
	"SOLE_PROPRIETOR",
	"LEGAL_ENTITY"
])).optional().describe("Фильтр по типу адресата ФЛ/ИП/ЮЛ (повторяемый параметр)");
const getRequestsQuerySectionSchema = z.string().optional().describe("УСТАРЕЛ, использовать sections: ILIKE-подстрока по месту (станция/перегон), поле section");
const getRequestsQueryApplicantNameSchema = z.string().optional().describe("УСТАРЕЛ, использовать applicantNames: ILIKE-подстрока по наименованию заявителя/адресата");
const getRequestsQueryInitiatorSchema = z.string().optional().describe("УСТАРЕЛ, использовать initiatorIds: ILIKE-подстрока по ФИО инициатора");
const getRequestsQuerySectionsSchema = z.array(z.string()).optional().describe("Станция/перегон — точные значения из списка доступных (повторяемый параметр)");
const getRequestsQueryApplicantNamesSchema = z.array(z.string()).optional().describe("Заявитель — точные значения из списка доступных (повторяемый параметр)");
const getRequestsQueryInitiatorIdsSchema = z.array(z.uuid()).optional().describe("Инициатор — id пользователей (повторяемый параметр). Фильтруем по id, а не по ФИО: полные тёзки склеились бы в одно значение");
const getRequestsQueryAssigneeIdsSchema = z.array(z.uuid()).optional().describe("Ответственный на текущем этапе — id пользователей (повторяемый параметр)");
const getRequestsQueryAssigneeUnassignedSchema = z.boolean().optional().describe("Включить заявки без ответственного на текущем этапе. Вместе с assigneeIds работает как ИЛИ: выбранные ответственные либо без ответственного");
const getRequestsQueryOperatorIdsSchema = z.array(z.uuid()).optional().describe("Оператор, выполнивший последнее действие по заявке — id пользователей (повторяемый параметр)");
const getRequestsQueryOperatorUnassignedSchema = z.boolean().optional().describe("Включить заявки без оператора (не было операторских действий). Вместе с operatorIds работает как ИЛИ: выбранные операторы либо без оператора");
const getRequestsQueryPaymentFlagSchema = z.array(z.enum([
	"UNDER_REVIEW",
	"NO_PAYMENT",
	"PAID"
])).optional().describe("Условия оплаты (повторяемый параметр)");
const getRequestsQueryProcessingFlagSchema = z.array(z.enum([
	"NEEDS_EXPORT",
	"EXPORTED",
	"LOADED"
])).optional().describe("Признак обработки Оператором (повторяемый параметр)");
const getRequestsQueryDeadlineControlSchema = z.array(z.enum([
	"PLANNED",
	"DEADLINE_APPROACHING",
	"RISK_OF_VIOLATION",
	"OVERDUE",
	"REVIEWED"
])).optional().describe("Контроль срока рассмотрения (повторяемый параметр). Значение вычисляется на лету из «Рассмотреть до», паузы и статуса");
const getRequestsQueryImportedFromSchema = z.iso.datetime().optional().describe("Дата поступления: начало периода включительно, ISO-8601 instant (2026-07-01T00:00:00Z)");
const getRequestsQueryImportedToSchema = z.iso.datetime().optional().describe("Дата поступления: конец периода включительно");
const getRequestsQueryProcessedFromSchema = z.iso.datetime().optional().describe("Дата обработки (выгрузки результата): начало периода включительно. Фильтрует по тому же выражению, что показано в ячейке: у невыгруженных заявок она пуста");
const getRequestsQueryProcessedToSchema = z.iso.datetime().optional().describe("Дата обработки: конец периода включительно");
const getRequestsQueryCreatedFromSchema = z.iso.datetime().optional().describe("Дата создания: начало периода включительно");
const getRequestsQueryCreatedToSchema = z.iso.datetime().optional().describe("Дата создания: конец периода включительно");
const getRequestsQueryUpdatedFromSchema = z.iso.datetime().optional().describe("Дата изменения: начало периода включительно");
const getRequestsQueryUpdatedToSchema = z.iso.datetime().optional().describe("Дата изменения: конец периода включительно");
const getRequestsQueryReviewDueFromSchema = z.iso.date().optional().describe("Рассмотреть до: начало периода включительно, ISO-дата (2026-07-01). Колонка хранит дату без времени, поэтому границы тоже даты, а не моменты").meta({ examples: ["2026-07-01"] });
const getRequestsQueryReviewDueToSchema = z.iso.date().optional().describe("Рассмотреть до: конец периода включительно").meta({ examples: ["2026-07-31"] });
const getRequestsQuerySortBySchema = z.enum([
	"NUMBER",
	"TITLE",
	"IMPORTED_AT",
	"REVIEW_DUE_DATE",
	"DEADLINE_CONTROL",
	"CREATED_AT",
	"UPDATED_AT",
	"TYPE",
	"REQUEST_SUBJECT",
	"STATUS",
	"RAILWAY",
	"SECTION",
	"PAYMENT_FLAG",
	"INVOICE_AMOUNT",
	"APPLICANT_NAME",
	"INITIATOR",
	"ASSIGNEE",
	"OPERATOR",
	"PROCESSING_FLAG",
	"RECEIVED_AT",
	"PROCESSED_AT"
]).optional().describe("Поле сортировки; без него — imported_at DESC");
const getRequestsQuerySortDirSchema = z.enum(["ASC", "DESC"]).optional().describe("Направление: строго ASC или DESC (регистрозависимо). Без sortBy игнорируется; с sortBy по умолчанию ASC");
const getRequestsQueryPageSchema = z.int().optional().describe("Номер страницы (с 0)");
const getRequestsQuerySizeSchema = z.int().optional().describe("Размер страницы");
const getRequestsQueryNeedsExportSchema = z.boolean().optional().describe("Только заявки, требующие выгрузки (терминальный статус без выгруженного результата, либо есть непереданный счёт — независимо от статуса)");
const getRequestsQueryHolderUserIdSchema = z.uuid().optional().describe("Только заявки, где указанный пользователь держит слот, которому принадлежит текущий статус заявки");
const getRequestsQueryMonitoringMetricSchema = z.enum([
	"TOTAL",
	"ACTIVE",
	"TU_ISSUED",
	"REJECTED",
	"PAID_SERVICE",
	"FREE_SERVICE",
	"INVOICE_TOTAL",
	"PAYMENT_TOTAL",
	"DEBT_TOTAL",
	"ACTIVE_PLANNED",
	"ACTIVE_APPROACHING",
	"ACTIVE_AT_RISK",
	"ACTIVE_OVERDUE",
	"ACTIVE_PAID_SERVICE",
	"ACTIVE_FREE_SERVICE",
	"ACTIVE_UNDEFINED_PAYMENT",
	"ACTIVE_AWAITING_INVOICE",
	"ACTIVE_AWAITING_PAYMENT",
	"ACTIVE_PAID",
	"ACTIVE_INVOICE_TOTAL",
	"ACTIVE_PAYMENT_TOTAL",
	"ACTIVE_DEBT_TOTAL"
]).optional().describe("Показатель мониторинга для перехода в список, AND с остальными фильтрами. Для НТП открывает заявки своей дороги вместо личных назначений; TOTAL — все заявки этой области. Доступен только Мониторингу, Начальнику НТП и Аппарату НГ");
const getRequestsQueryInvoiceAmountFromSchema = z.number().optional().describe("Стоимость услуги: нижняя граница включительно, рубли");
const getRequestsQueryInvoiceAmountToSchema = z.number().optional().describe("Стоимость услуги: верхняя граница включительно, рубли");
const getRequestsStatus200Schema = pageResponseSchema.describe("Пагинированный ответ");
const getRequestsResponseSchema = getRequestsStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/getVersionsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getVersionsPathRequestIdSchema = z.uuid();
const getVersionsStatus200Schema = z.array(finalDecisionVersionDtoSchema);
const getVersionsResponseSchema = getVersionsStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/importItemResultSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const importItemResultSchema = z.object({
	attachmentsAdded: z.array(z.string()).nullish().describe("Имена вложений, добавленных этим импортом; при outcome=CONFLICT — какие вложения были бы добавлены, если бы не конфликт (фактически не загружены)"),
	attachmentsMissing: z.array(z.string()).nullish().describe("Имена вложений, которые есть у заявки, но отсутствуют в архиве (признак устаревших данных при outcome=CONFLICT)"),
	commentsImported: z.int().nullish().describe("Сколько комментариев перенесено (новых, ранее не импортированных)"),
	errors: z.array(z.string()).nullish().describe("Список ошибок, если outcome=FAILED"),
	externalRequestId: z.uuid().nullish().describe("Идентификатор заявки во внешнем контуре; null, если request.json не распарсился"),
	filesImported: z.int().nullish().describe("Сколько документов загружено (новых, ранее отсутствовавших)"),
	newStatus: z.string().nullish().describe("Статус заявки после импорта"),
	number: z.int().nullish().describe("Номер заявки").meta({ examples: [1001] }),
	outcome: z.enum([
		"CREATED",
		"UPDATED",
		"NO_CHANGE",
		"CONFLICT",
		"FAILED"
	]).optional().describe("Исход: CREATED | UPDATED | NO_CHANGE | CONFLICT | FAILED"),
	previousStatus: z.string().nullish().describe("Статус заявки до импорта (для CONFLICT/NO_CHANGE — текущий статус)"),
	title: z.string().nullish().describe("Заголовок заявки")
}).describe("Результат импорта одной заявки из архива");
//#endregion
//#region src/__generated__/internal/application/zod/importSummaryResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const importSummaryResponseSchema = z.object({
	conflict: z.int().nullish().describe("Не обновлено из-за конфликта (в архиве более старые данные)"),
	created: z.int().nullish().describe("Создано новых заявок"),
	failed: z.int().nullish().describe("Пропущено некорректных заявок"),
	items: z.array(importItemResultSchema).nullish().describe("Детализация по каждой заявке"),
	noChange: z.int().nullish().describe("Без изменений (данные заявки совпадают с уже сохранёнными)"),
	totalFound: z.int().nullish().describe("Всего заявок найдено в архиве"),
	updated: z.int().nullish().describe("Обновлено существующих заявок")
}).describe("Сводка результата массового импорта заявок");
//#endregion
//#region src/__generated__/internal/application/zod/importRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const importRequestStatus200Schema = importSummaryResponseSchema.describe("Сводка результата массового импорта заявок");
const importRequestResponseSchema = importRequestStatus200Schema;
const importRequestDataSchema = z.object({ file: z.instanceof(File) }).optional();
//#endregion
//#region src/__generated__/internal/application/zod/tuPartDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const tuPartDtoSchema = z.object({
	departmentId: z.string().describe("Идентификатор ответственного регионального подразделения"),
	departmentName: z.string().describe("Название ответственного регионального подразделения"),
	fileId: z.uuid().nullish().describe("Идентификатор актуального файла части ТУ; null, если файл не привязан")
}).describe("Часть ТУ ответственного регионального подразделения");
//#endregion
//#region src/__generated__/internal/application/zod/listSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const listPathRequestIdSchema = z.uuid();
const listStatus200Schema = z.array(tuPartDtoSchema);
const listResponseSchema = listStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/attachmentDescriptionDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const attachmentDescriptionDtoSchema = z.object({
	description: z.string().nullish().describe("Описание файла"),
	fileId: z.uuid().nullish().describe("Идентификатор файла в file-service")
}).describe("Описание приложенного файла");
//#endregion
//#region src/__generated__/internal/application/zod/listAttachmentDescriptionsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const listAttachmentDescriptionsPathIdSchema = z.uuid();
const listAttachmentDescriptionsStatus200Schema = z.array(attachmentDescriptionDtoSchema);
const listAttachmentDescriptionsResponseSchema = listAttachmentDescriptionsStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/attachmentDescriptionBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const attachmentDescriptionBodySchema = z.object({ description: z.string().min(0).max(2e3).optional().describe("Описание файла").meta({ examples: ["Схема примыкания, лист 1"] }) }).describe("Тело запроса на установку описания вложения");
//#endregion
//#region src/__generated__/internal/application/zod/setAttachmentDescriptionSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const setAttachmentDescriptionPathIdSchema = z.uuid();
const setAttachmentDescriptionPathFileIdSchema = z.uuid();
const setAttachmentDescriptionStatus200Schema = attachmentDescriptionDtoSchema.describe("Описание приложенного файла");
const setAttachmentDescriptionResponseSchema = setAttachmentDescriptionStatus200Schema;
const setAttachmentDescriptionDataSchema = attachmentDescriptionBodySchema.describe("Тело запроса на установку описания вложения");
//#endregion
//#region src/__generated__/internal/application/zod/transitionCommandSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const transitionCommandSchema = z.object({
	assigneeId: z.uuid().optional(),
	comment: z.string().optional(),
	documentIds: z.array(z.uuid()).optional(),
	resultFileId: z.uuid().optional()
});
//#endregion
//#region src/__generated__/internal/application/zod/transitionSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const transitionPathRequestIdSchema = z.uuid();
const transitionPathActionSchema = z.string();
const transitionStatus204Schema = z.unknown();
const transitionResponseSchema = transitionStatus204Schema;
const transitionDataSchema = transitionCommandSchema.optional();
//#endregion
//#region src/__generated__/internal/application/zod/unlinkSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const unlinkPathRequestIdSchema = z.uuid();
const unlinkPathFileIdSchema = z.uuid();
const unlinkStatus200Schema = z.unknown();
const unlinkResponseSchema = unlinkStatus200Schema;
//#endregion
//#region src/__generated__/internal/application/zod/updateSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updatePathRequestIdSchema = z.uuid();
const updateStatus200Schema = finalDecisionDtoSchema.describe("Черновик итогового решения");
const updateResponseSchema = updateStatus200Schema;
const updateDataSchema = finalDecisionBodySchema.describe("Данные черновика итогового решения");
//#endregion
export { getRequestsQueryNeedsExportSchema as $, approverDtoSchema as $t, importRequestResponseSchema as A, deleteAttachmentDescriptionResponseSchema as An, getRefusalPathRequestIdSchema as At, getRequestsQueryAssigneeIdsSchema as B, createResponseSchema as Bn, pageResponseSchema as Bt, listAttachmentDescriptionsStatus200Schema as C, requestExportRequestSchema as Cn, getRequestPathIdSchema as Ct, listStatus200Schema as D, deleteRemarkStatus204Schema as Dn, stageAssignmentDtoSchema as Dt, listResponseSchema as E, deleteRemarkResponseSchema as En, internalRequestDetailResponseSchema as Et, getVersionsResponseSchema as F, createRemarkStatus200Schema as Fn, getNeedsAttentionQueryPageSchema as Ft, getRequestsQueryHolderUserIdSchema as G, bindPathDepartmentIdSchema as Gn, statusChangePayloadSchema as Gt, getRequestsQueryCreatedFromSchema as H, finalDecisionDtoSchema as Hn, getHistoryResponseSchema as Ht, getVersionsStatus200Schema as I, finalDecisionRemarkDtoSchema as In, getNeedsAttentionQuerySearchSchema as It, getRequestsQueryInitiatorIdsSchema as J, bindResponseSchema as Jn, paymentConfirmationPayloadSchema as Jt, getRequestsQueryImportedFromSchema as K, bindPathFileIdSchema as Kn, reasonPayloadSchema as Kt, getRequestsQueryApplicantNameSchema as L, finalDecisionRemarkBodySchema as Ln, getNeedsAttentionQuerySizeSchema as Lt, importSummaryResponseSchema as M, createRemarkDataSchema as Mn, getRefusalStatus200Schema as Mt, importItemResultSchema as N, createRemarkPathRequestIdSchema as Nn, finalDecisionRefusalDtoSchema as Nt, tuPartDtoSchema as O, deleteAttachmentDescriptionPathFileIdSchema as On, fileMetaDtoSchema as Ot, getVersionsPathRequestIdSchema as P, createRemarkResponseSchema as Pn, finalDecisionRefusalDocumentDtoSchema as Pt, getRequestsQueryMonitoringMetricSchema as Q, assignmentPayloadSchema as Qt, getRequestsQueryApplicantNamesSchema as R, createDataSchema as Rn, getNeedsAttentionResponseSchema as Rt, listAttachmentDescriptionsResponseSchema as S, exportRequestsStatus200Schema as Sn, getRequestsStatus200Schema as St, listPathRequestIdSchema as T, deleteRemarkPathRequestIdSchema as Tn, getRequestStatus200Schema as Tt, getRequestsQueryCreatedToSchema as U, finalDecisionAuthorDtoSchema as Un, getHistoryStatus200Schema as Ut, getRequestsQueryAssigneeUnassignedSchema as V, createStatus200Schema as Vn, getHistoryPathIdSchema as Vt, getRequestsQueryDeadlineControlSchema as W, finalDecisionBodySchema as Wn, internalRequestEventLogDtoSchema as Wt, getRequestsQueryInvoiceAmountFromSchema as X, tuPartBindResultSchema as Xn, importPayloadSchema as Xt, getRequestsQueryInitiatorSchema as Y, bindStatus200Schema as Yn, invoicePayloadSchema as Yt, getRequestsQueryInvoiceAmountToSchema as Z, emptyPayloadSchema as Zt, setAttachmentDescriptionPathIdSchema as _, get2PathRequestIdSchema as _n, getRequestsQueryStatusSchema as _t, unlinkPathFileIdSchema as a, getFilterValuesResponseSchema as an, getRequestsQueryProcessedToSchema as at, attachmentDescriptionBodySchema as b, exportRequestsDataSchema as bn, getRequestsQueryUpdatedToSchema as bt, unlinkStatus200Schema as c, getCurrentVersionPathRequestIdSchema as cn, getRequestsQueryRequestSubjectSchema as ct, transitionPathRequestIdSchema as d, finalDecisionVersionDtoSchema as dn, getRequestsQuerySearchSchema as dt, getFilterValuesQueryColumnSchema as en, getRequestsQueryOperatorIdsSchema as et, transitionResponseSchema as f, finalDecisionApprovalDtoSchema as fn, getRequestsQuerySectionSchema as ft, setAttachmentDescriptionPathFileIdSchema as g, tileCountSchema as gn, getRequestsQuerySortDirSchema as gt, setAttachmentDescriptionDataSchema as h, requestStatusCountsSchema as hn, getRequestsQuerySortBySchema as ht, updateStatus200Schema as i, getFilterValuesQuerySelectedSchema as in, getRequestsQueryProcessedFromSchema as it, importRequestStatus200Schema as j, deleteAttachmentDescriptionStatus204Schema as jn, getRefusalResponseSchema as jt, importRequestDataSchema as k, deleteAttachmentDescriptionPathIdSchema as kn, applicantDtoSchema as kt, transitionDataSchema as l, getCurrentVersionResponseSchema as ln, getRequestsQueryReviewDueFromSchema as lt, transitionCommandSchema as m, getCountsStatus200Schema as mn, getRequestsQuerySizeSchema as mt, updatePathRequestIdSchema as n, getFilterValuesQueryMonitoringMetricSchema as nn, getRequestsQueryPageSchema as nt, unlinkPathRequestIdSchema as o, getFilterValuesStatus200Schema as on, getRequestsQueryProcessingFlagSchema as ot, transitionStatus204Schema as p, getCountsResponseSchema as pn, getRequestsQuerySectionsSchema as pt, getRequestsQueryImportedToSchema as q, bindPathRequestIdSchema as qn, paymentFlagPayloadSchema as qt, updateResponseSchema as r, getFilterValuesQueryQSchema as rn, getRequestsQueryPaymentFlagSchema as rt, unlinkResponseSchema as s, filterValueItemSchema as sn, getRequestsQueryRailwaySchema as st, updateDataSchema as t, getFilterValuesQueryLimitSchema as tn, getRequestsQueryOperatorUnassignedSchema as tt, transitionPathActionSchema as u, getCurrentVersionStatus200Schema as un, getRequestsQueryReviewDueToSchema as ut, setAttachmentDescriptionResponseSchema as v, get2ResponseSchema as vn, getRequestsQueryTypeSchema as vt, attachmentDescriptionDtoSchema as w, deleteRemarkPathRemarkIdSchema as wn, getRequestResponseSchema as wt, listAttachmentDescriptionsPathIdSchema as x, exportRequestsResponseSchema as xn, getRequestsResponseSchema as xt, setAttachmentDescriptionStatus200Schema as y, get2Status200Schema as yn, getRequestsQueryUpdatedFromSchema as yt, getRequestsQueryApplicantTypeSchema as z, createPathRequestIdSchema as zn, getNeedsAttentionStatus200Schema as zt };

//# sourceMappingURL=updateSchema.js.map